import { render, staticRenderFns } from "./TourFrame.vue?vue&type=template&id=0adacb22&scoped=true&"
import script from "./TourFrame.vue?vue&type=script&lang=js&"
export * from "./TourFrame.vue?vue&type=script&lang=js&"
import style0 from "./TourFrame.vue?vue&type=style&index=0&id=0adacb22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adacb22",
  null
  
)

export default component.exports